import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';
import { LINK_COLORS } from '@wds/helpers';

import useStyles from './useStyles';

const Link = ({ children, color, underline, ...rest }) => {
  const theme = useTheme();
  const { wrenchLink } = useStyles({ color, underline, theme });
  return (
    <a className={wrenchLink} {...safeRest(rest)}>
      {children}
    </a>
  );
};

Link.propTypes = {
  /**
   * Content of link
   */
  children: PropTypes.node.isRequired,
  /**
   * Color variants
   */
  color: PropTypes.oneOf(LINK_COLORS),
  /**
   * If false, will not display underline for link
   */
  underline: PropTypes.bool,
};

Link.defaultProps = {
  color: 'dark',
  underline: true,
};

export default Link;
